import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const SessionReadSlice = createSlice({
  name: "SessionReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    SessionRead: (state) => {
      state.isLoading = true;
    },
    successSessionRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureSessionRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearSessionRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  SessionRead,
  successSessionRead,
  failureSessionRead,
  clearSessionRead,
} = SessionReadSlice.actions;

export default SessionReadSlice.reducer;
